export default [
  {
    order: 1,
    personName: 'Ola',
    header: 'Absolutely obsessed with Zola',
    description:
      'Zola is truly a fantastic experience, from the planning to the save the dates, invites, everything! I love the checklist and the beautiful designs for website and invites. Also, anytime I email with a question the response is super fast!',
  },
  {
    order: 2,
    personName: 'Jaz',
    header: 'Thank you Zola!!!',
    description:
      "Zola made it so easy to plan our wedding. The planning checklists were incredibly helpful, and their free website and registry services were easy to use and looked amazing. Purchasing items from our registry after the ceremony was simple and easy, and if I had to do it all again I wouldn't change a thing!",
  },
  {
    order: 3,
    personName: 'OHughes',
    header: 'Zola has everything!',
    description:
      'I’d recommend Zola to ANYONE and everyone getting married. They have literally everything - plus the 20% post married discount is insane!',
  },
  {
    order: 4,
    personName: 'Karl',
    header: 'Huge help',
    description:
      'It was a great website, especially if you have no idea what you are doing and you need help.',
  },
  {
    order: 5,
    personName: 'Kyla',
    header: 'Amazing free benefits',
    description:
      'There are many sites out there that advertise free things, but Zola is honest on their offers. You can create a free wedding website, and order a trial of their invitations for completely free. The fact that you can actually get an invitation in person and see what it will look and feel like is huge.',
  },
  {
    order: 6,
    personName: 'Shu',
    header: "Couldn't be happier!",
    description:
      'So thankful a friend recommended me to Zola! Best experience having a central space to keep my guest list and wedding day plans all in one place! Thank you for making this so easy!',
  },
  {
    order: 7,
    personName: 'Deb',
    header: 'Easy and simple',
    description:
      'I have enjoyed the experience of creating my invitations on the Zola site, as well as designing my website and creating my registry.',
  },
  {
    order: 8,
    personName: 'ChelRay',
    header: 'Great!',
    description:
      'I used Zola to set up my wedding website and it was great! Setting up the site and the registry was simple and easy.',
  },
  {
    order: 9,
    personName: 'Kaitlynn',
    header: 'Nothing better',
    description:
      'We loved using Zola for our own wedding. It was easy to place all of our gifts onto one page. It was user friendly for all guests.',
  },
  {
    order: 10,
    personName: 'Em',
    header: 'The best',
    description:
      'This website has taken the burden out of wedding planning! I love how it coordinates with the app as well.',
  },
  {
    order: 11,
    personName: 'Ali',
    header: 'Love love love this site',
    description: 'Made wedding planning so easy!',
  },
  {
    order: 12,
    personName: 'Gina',
    header: 'TWe love you, Zola!!',
    description: 'We set up a free wedding website that is gorgeous and looks so professional.',
  },
];
